export const RESOURCE_TYPE_PERSONNEL = 'Personnel';
export const RESOURCE_TYPE_EQUIPMENT = 'Equipment';
export const RESOURCE_TYPE_EXPENSE = 'Expense';
export const RESOURCE_TYPE_SUBCONTRACT = 'Contract';
